import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { EndpointsService } from './endpoints.service';
import { lastValueFrom } from 'rxjs';
import { ToolsControlService } from './tools-control.service';
import { SelfTrainingToolExercise } from '../models/selfTrainingToolExercise';
import { cloneDeep } from 'lodash';



@Injectable({
  providedIn: 'root'
})
export class SelfTrainingToolService {

  active: boolean;
  loading: boolean = false;

  exerciseList: SelfTrainingToolExercise[] = [];
  exerciseListBackUp: SelfTrainingToolExercise[] = [];

  xwikiLink: string;
  xwikiUsername: string;
  xwikiPassword: string;

  constructor(
    public http : HttpClient,
    public endpointService: EndpointsService,
    public toolsService : ToolsControlService,
  ) { }

  async openWindow(){
    this.active = true;
    this.toolsService.navigationOnTop = true;
    if (this.exerciseList.length > 0){
      return;
    }
    this.loading = true;

    const loginInfo: string[] = await this.getLoginInfo();

    this.xwikiLink = loginInfo[0] + 'rest/wikis/xwiki/spaces/SELF%20TRAINING%20TOOL/spaces/pages/WebHome/children';
    this.xwikiUsername = loginInfo[1];
    this.xwikiPassword = loginInfo[2];

    const savedExercises = await this.getSavedExercises();
    this.getExercises(savedExercises);
    this.loading = false;
  }

  closeWindow():void{
    this.active = false;
    this.toolsService.navigationOnTop = false;
    this.exerciseList = [];
    this.exerciseListBackUp = [];
    this.xwikiLink = null;
    this.xwikiUsername = null;
    this.xwikiPassword = null;
  }

  hideWindow():void{
    this.active = false;
  }

  async getExercises(savedExercises: SelfTrainingToolExercise[]){

    /*const headers = new HttpHeaders({
      Authorization: 'Basic ' + btoa(`${this.xwikiUsername}:${this.xwikiPassword}`),
      //'Content-Type': 'application/json'
    });*/

    const pages: any = await lastValueFrom(this.http.get<any>(this.xwikiLink/*, { headers }*/));

    for (const page of pages.pageSummaries){

      const exercise: SelfTrainingToolExercise = new SelfTrainingToolExercise();
      exercise.title = page.title;
      var linkToExercise = this.replaceBaseUrl(page.xwikiAbsoluteUrl, this.xwikiLink);
      exercise.linkToPage = SelfTrainingToolService.removePortFromUrl(linkToExercise);

      const findSpaceLinkObject: any = (page.links as any[]).find(link => link.rel == 'http://www.xwiki.org/rel/page');
      if (findSpaceLinkObject == null) {
        continue;
      }

      let fetchTagLink: string = `${findSpaceLinkObject.href}/tags`;
      fetchTagLink = fetchTagLink.replace("http://", "https://");
      fetchTagLink = this.replaceBaseUrl(fetchTagLink, this.xwikiLink);
      const tags: any = await lastValueFrom(this.http.get<any>(fetchTagLink/*, { headers }*/));
      if (tags.tags.length == 0) {
        continue;
      }
      exercise.uniqueId = tags.tags[0].name;
      const indexOfSavedExercise: number = savedExercises.findIndex(e => e.uniqueId == exercise.uniqueId);
      if (indexOfSavedExercise != -1){
        const savedExercise = savedExercises.splice(indexOfSavedExercise, 1)[0];
        exercise.done = savedExercise.done;
        exercise.comments = savedExercise.comments;
        if (exercise.comments == null){
          exercise.comments = "";
        }
      }
      this.exerciseList.push(exercise);
    }
    this.exerciseListBackUp = cloneDeep(this.exerciseList);

    if (savedExercises.length > 0){
      this.deleteSavedExercises(savedExercises.map(e => e.uniqueId));
    }

  }

  replaceBaseUrl(url: string, newBaseUrl: string): string {
    const parsed = new URL(url);     // parses any URL
    const newParsed = new URL(newBaseUrl);

    // Keep only the path + search + hash from the original URL
    return newParsed.origin + parsed.pathname + parsed.search + parsed.hash;
  }


  async getSavedExercises(): Promise<SelfTrainingToolExercise[]>{
    return await lastValueFrom(this.http.get<SelfTrainingToolExercise[]>(this.endpointService.selfTrainingToolDemeterAPI, this.endpointService.httpOptions));
  }

  async saveExercises(exercises: SelfTrainingToolExercise []){
    await lastValueFrom(this.http.post<boolean>(this.endpointService.endpointSaveSelfTrainingExercises, exercises, this.endpointService.httpOptions));
  }

  async deleteSavedExercises(ids: string []){
    await lastValueFrom(this.http.post<boolean>(this.endpointService.endpointSelfTrainingExercisesBulkDelete, ids, this.endpointService.httpOptions));
  }

  async getLoginInfo(){
    return await lastValueFrom(this.http.get<string[]>(this.endpointService.endpointgetXwikiLoginInfo, this.endpointService.httpOptions));
  }



  public static removePortFromUrl(url: string): string {
    // Create a URL object
    const parsedUrl = new URL(url);

    // Set the port to an empty string (removing it)
    parsedUrl.port = '';

    // Convert the URL object back to a string
    const updatedUrl = parsedUrl.toString();

    return updatedUrl;
  }
}
